import React from 'react';
import { Helmet } from 'react-helmet';

interface MetaTagsProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
}

/**
 * Component to dynamically update meta tags for social media sharing
 */
const MetaTags: React.FC<MetaTagsProps> = ({
  title = "Consent is what you need",
  description = "BodySharing - We create safe spaces for consensual connections and physical exploration.",
  image = "/images/og-image.jpg",
  url,
}) => {
  // Use the current URL if none provided
  const pageUrl = url || window.location.href;
  // Get the absolute URL for the image
  const absoluteImageUrl = image.startsWith('http') 
    ? image 
    : `${window.location.origin}${image}`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={absoluteImageUrl} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={pageUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={absoluteImageUrl} />
    </Helmet>
  );
};

export default MetaTags;